export default "__VITE_ASSET__G5$UE2My__"